<h3 [style]="titleAndTextStyles()">{{ title() }}</h3>

@if (dismissable()) {
  <i class="fas fa-times dismiss-icon" (click)="onDismiss.emit()"></i>
}

<div class="text-and-link-container">
  <span [style]="titleAndTextStyles()" class="vertical-align-middle notification-text" [innerHTML]="text() ? text() : ''"></span>

  @if (hasButton()) {
    <p-button class="vertical-align-middle" [link]="true" styleClass="text-sm {{ newLineButtonClass() }}" [label]="buttonText()" (click)="buttonClick.emit()" />
  }
</div>
